import { MODE_OF_TRANSPORT_EXPRESS_ROAD } from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const validateConsignmentStreetRequirement = ({
  security,
}: {
  security: string
}) : RuleResult => (['1', '3'].includes(security) ? 'REQUIRED' : 'NOT_ALLOWED')

const validateHouseConsignmentStreetRequirement = ({
  security,
  specificCircumstanceIndicator,
}: {
  security: string
  specificCircumstanceIndicator?: string
}) : RuleResult => (['1', '3'].includes(security) && specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD ? 'REQUIRED' : 'NOT_ALLOWED')

const C0037Validator = {
  validateConsignmentConsigneeStreetRequirement: validateConsignmentStreetRequirement,
  validateConsignmentConsignorStreetRequirement: validateConsignmentStreetRequirement,
  validateHouseConsignmentConsigneeStreetRequirement: validateHouseConsignmentStreetRequirement,
  validateHouseConsignmentConsignorStreetRequirement: validateHouseConsignmentStreetRequirement,
}

export default C0037Validator
